<template>
  <div class="text-center mt-10">
    <h1 class="text-4xl font-bold">404</h1>
    <p class="text-lg mt-2">Oops! Page not found.</p>
    <router-link to="/" class="text-blue-500 hover:underline mt-4 block">Go back home</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
